import ImportWizard from "@components/content/ImportWizard";
import { productImportDefinition } from "@utils/import/definitions/productImport";

const ProductImport = () => <ImportWizard definition={productImportDefinition} />;

export default ProductImport;
